module.exports = __webpack_public_path__ + "img/bg.911652e4.png";